import { t as throttle } from './index2.js';

var hotspotsMixin = {
  props: {
    hotspots: {
      type: Array
    }
  },
  computed: {
    htmlIconHotspots: function htmlIconHotspots() {
      var _this = this;

      return this.hotspots.filter(function (item) {
        return item.shape === 'rect' && (_this.$xp.settings.mergedSettings.navigation.imageMapDefaultIcon && item.icon !== '' || !_this.$xp.settings.mergedSettings.navigation.imageMapDefaultIcon && item.icon > '');
      }).map(function (item) {
        return {
          centerYPercent: (item.tl.y + item.br.y) / 2 / 100,
          centerXPercent: (item.tl.x + item.br.x) / 2 / 100,
          alt: item.alt,
          href: _this.$router.resolve(item.href).href,
          route: item.href,
          icon: item.icon || 'default'
        };
      });
    }
  },
  created: function created() {
    this.hotspotClicked = throttle(this.hotspotClicked);
  },
  methods: {
    checkForHotspot: function checkForHotspot(coords) {
      var _this2 = this;

      this.hotspots.map(function (hotspot) {
        switch (hotspot.shape) {
          case 'poly':
            if (_this2.isInPolyHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;

          case 'circle':
            if (_this2.isInCircleHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;

          case 'rect':
            if (_this2.isInRectHotspot(coords, hotspot)) {
              _this2.hotspotClicked(hotspot);

              return true;
            }

            break;
        }
      });
    },
    isInCircleHotspot: function isInCircleHotspot(point, hotspot) {
      return Math.sqrt(Math.pow(point[0] - hotspot.center.x, 2) + Math.pow(point[1] - hotspot.center.y, 2)) <= hotspot.radius;
    },
    isInRectHotspot: function isInRectHotspot(point, hotspot) {
      return point[0] >= hotspot.tl.x && point[0] <= hotspot.br.x && point[1] > hotspot.tl.y && point[1] <= hotspot.br.y;
    },
    isInPolyHotspot: function isInPolyHotspot(point, hotspot) {
      var vs = hotspot.points.map(function (point) {
        return [point.x, point.y];
      });
      var x = point[0];
      var y = point[1];
      var inside = false;

      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0];
        var yi = vs[i][1];
        var xj = vs[j][0];
        var yj = vs[j][1];
        var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
      }

      return inside;
    },
    hotspotClicked: function hotspotClicked(hotspot) {
      this.$emit('hotspot-click', hotspot);
    }
  }
};

export { hotspotsMixin as h };
